/**
 * A candidate is a user going through onboarding with temporary credentials: they carry the
 * employee role but are not approved yet, so they only get the candidate onboarding portal.
 */
export function isOnboardingCandidate(user) {
  if (!user) return false;
  return user.role === 'employee' && !!user.isSelfOnboarding && user.onboardingStatus !== 'approved';
}

/** Where a signed-in user belongs after login. */
export function homePathForUser(user) {
  if (!user) return '/login';
  if (user.role === 'admin') return '/admin';
  if (user.role === 'superadmin') return '/superadmin';
  if (isOnboardingCandidate(user)) return '/candidate';
  return '/employee';
}
